import { RETAIL_GET_STARTED } from '@square/dashboard-data/models/squareup/setup-guide/config/video-src';
import { RETAIL_HOW_TO_GET_STARTED_IMG } from '@square/dashboard-data/models/squareup/setup-guide/config/image-src';
import Enum from '@square/dashboard-utilities/utils/enum';
export const MilestonesVariantTypes = Enum.create('REGISTER_POS', 'RETAIL', 'RST', 'TERMINAL', 'DEFAULT', 'MIXED', 'RST_FREE', 'ONLINE_CHECKOUT', 'APPOINTMENTS_ONBOARDING', 'GOLDEN_PATH_QSR');
export const MilestoneTypes = Enum.create('ECOMMERCE_PLUS', 'POS_BUILD_POS', 'POS_SET_UP_ACCOUNT', 'POS_DOWNLOAD_APP_AND_ORDER_HARDWARE', 'POS_GET_PAID', 'RETAIL_SET_UP_STORE', 'RETAIL_SET_UP_CATALOG', 'RETAIL_DOWNLOAD_APP_AND_ORDER_HARDWARE', 'RETAIL_GET_PAID', 'RETAIL_SET_UP_ONLINE_SALES_CHANNELS', 'RST_EXPLORE_ADVANCED_SET_UP', 'RST_SET_UP_BUSINESS', 'RST_SET_UP_POINT_OF_SALE', 'RST_POINT_OF_SALE', 'RST_GET_PAID', 'RST_ORDER_HUB', 'RST_WATCH_TOUR', 'UNGROUPED', 'TERMINAL_GET_PAID', 'TERMINAL_HARDWARE_DOWNLOAD', 'TERMINAL_SET_UP_ACCOUNT', 'INVOICES_CREATE_FIRST', 'INVOICES_DOWNLOAD_APP', 'INVOICES_GET_PAID', 'DEFAULT_SET_UP_ACCOUNT', 'DEFAULT_GET_PAID', 'RETAIL_WATCH_TOUR', 'DEFAULT_SET_UP_BUSINESS', 'DEFAULT_DOWNLOAD_APP_BUY_HARDWARE', 'ACTIVATE_PAYMENTS', 'SET_UP_ACCOUNT', 'SET_UP_RESTAURANT', 'SET_UP_RETAIL', 'SET_UP_ITEM_CATALOG', 'SET_UP_SPOS', 'SET_UP_ONLINE_STORE', 'SET_UP_INVOICES', 'SET_UP_EMPLOYEES', 'SET_UP_KDS', 'SET_UP_ONLINE_CHECKOUT', 'SET_UP_APPOINTMENTS', 'ONBOARD_TO_RESTAURANTS', 'DYNAMIC_SETUP');

/* Milestones Configuration.
 * Each Milestone can have the following keys:
 *   title: key for the title text
 *   icon: path of icon
 */
export const MilestonesConfig = {
  [MilestoneTypes.ECOMMERCE_PLUS]: {
    title: 'setupGuide.milestones.ecommercePlus.title',
    icon: 'svgs/icons/download-app'
  },
  [MilestoneTypes.POS_BUILD_POS]: {
    title: 'setupGuide.milestones.pos.buildPointOfSale.title',
    icon: 'svgs/icons/register'
  },
  [MilestoneTypes.POS_SET_UP_ACCOUNT]: {
    title: 'setupGuide.milestones.pos.setUpYourAccount.title',
    icon: 'svgs/icons/my-account'
  },
  [MilestoneTypes.POS_DOWNLOAD_APP_AND_ORDER_HARDWARE]: {
    title: 'setupGuide.milestones.pointOfSale.title',
    icon: 'svgs/icons/download-app'
  },
  [MilestoneTypes.POS_GET_PAID]: {
    title: 'setupGuide.milestones.getPaid.title',
    icon: 'svgs/icons/download-app'
  },
  [MilestoneTypes.RETAIL_SET_UP_STORE]: {
    title: 'setupGuide.milestones.retail.setUpYourStore.title',
    icon: 'svgs/icons/download-app'
  },
  [MilestoneTypes.RETAIL_SET_UP_CATALOG]: {
    title: {
      [MilestonesVariantTypes.RETAIL]: 'setupGuide.milestones.retail.setUpYourCatalog.title',
      [MilestonesVariantTypes.MIXED]: 'setupGuide.milestones.mixed.setUpYourCatalog.title'
    },
    icon: 'svgs/icons/tag'
  },
  [MilestoneTypes.RETAIL_DOWNLOAD_APP_AND_ORDER_HARDWARE]: {
    title: 'setupGuide.milestones.retail.pointOfSale.title',
    icon: 'svgs/icons/register'
  },
  [MilestoneTypes.RETAIL_GET_PAID]: {
    title: 'setupGuide.milestones.retail.getPaid.title',
    icon: 'svgs/icons/my-account'
  },
  [MilestoneTypes.RETAIL_SET_UP_ONLINE_SALES_CHANNELS]: {
    title: 'setupGuide.milestones.retail.setUpOnlineSalesChannels.title',
    icon: 'svgs/icons/sell-online'
  },
  [MilestoneTypes.RST_EXPLORE_ADVANCED_SET_UP]: {
    title: 'setupGuide.milestones.restaurants.exploreAdvancedSetUp.title',
    icon: 'svgs/icons/four-squares'
  },
  [MilestoneTypes.RST_SET_UP_BUSINESS]: {
    title: 'setupGuide.milestones.restaurants.setUpYourRestaurant.title',
    icon: 'svgs/icons/to-do-list'
  },
  [MilestoneTypes.RST_SET_UP_POINT_OF_SALE]: {
    description: 'setupGuide.milestones.restaurants.setUpPointOfSale.description',
    title: 'setupGuide.milestones.restaurants.setUpPointOfSale.title',
    icon: 'svgs/icons/register'
  },
  [MilestoneTypes.RST_ORDER_HUB]: {
    title: 'setupGuide.milestones.restaurants.orderHub.title',
    alwaysApplicable: true,
    linkTo: 'orders.channels',
    icon: 'svgs/icons/shopping-bag'
  },
  [MilestoneTypes.RST_POINT_OF_SALE]: {
    title: 'setupGuide.milestones.pointOfSale.title',
    icon: 'svgs/icons/register'
  },
  [MilestoneTypes.RST_GET_PAID]: {
    title: 'setupGuide.milestones.getPaid.title',
    icon: 'svgs/icons/money'
  },
  [MilestoneTypes.RST_WATCH_TOUR]: {
    title: 'setupGuide.actionItems.rstWatchTour.title',
    alwaysApplicable: true,
    icon: 'svgs/icons/play'
  },
  [MilestoneTypes.RETAIL_WATCH_TOUR]: {
    title: {
      [MilestonesVariantTypes.MIXED]: 'setupGuide.milestones.watchTour.retail.mixed.title',
      [MilestonesVariantTypes.RETAIL]: 'setupGuide.milestones.watchTour.retail.title'
    },
    alwaysApplicable: true,
    video: {
      src: RETAIL_GET_STARTED,
      type: 'video/mp4',
      poster: RETAIL_HOW_TO_GET_STARTED_IMG,
      duration: '1:20',
      eventType: 'Watch Retail Tour'
    },
    icon: 'svgs/icons/download-app'
  },
  [MilestoneTypes.UNGROUPED]: {
    title: 'setupGuide.title'
  },
  [MilestoneTypes.TERMINAL_GET_PAID]: {
    title: 'setupGuide.milestones.getPaid.title',
    icon: 'svgs/icons/money'
  },
  [MilestoneTypes.TERMINAL_HARDWARE_DOWNLOAD]: {
    title: 'setupGuide.milestones.terminal.hardwareDownload.title',
    icon: 'svgs/icons/download-app'
  },
  [MilestoneTypes.TERMINAL_SET_UP_ACCOUNT]: {
    title: 'setupGuide.milestones.terminal.setUpAccount.title',
    icon: 'svgs/icons/my-account'
  },
  [MilestoneTypes.INVOICES_CREATE_FIRST]: {
    title: 'setupGuide.milestones.invoicesCreateFirst.title',
    icon: 'svgs/icons/invoice'
  },
  [MilestoneTypes.INVOICES_DOWNLOAD_APP]: {
    title: 'setupGuide.milestones.invoicesDownloadApp.title',
    icon: 'svgs/icons/download-app'
  },
  [MilestoneTypes.INVOICES_GET_PAID]: {
    title: 'setupGuide.milestones.getPaid.title',
    icon: 'svgs/icons/money'
  },
  [MilestoneTypes.DEFAULT_SET_UP_ACCOUNT]: {
    title: 'setupGuide.milestones.terminal.setUpAccount.title',
    icon: 'svgs/icons/my-account'
  },
  [MilestoneTypes.DEFAULT_GET_PAID]: {
    title: 'setupGuide.milestones.getPaid.title',
    icon: 'svgs/icons/money'
  },
  [MilestoneTypes.DEFAULT_SET_UP_BUSINESS]: {
    title: 'setupGuide.milestones.setUpBusiness.title',
    icon: 'svgs/icons/to-do-list'
  },
  [MilestoneTypes.DEFAULT_DOWNLOAD_APP_BUY_HARDWARE]: {
    title: 'setupGuide.milestones.downloadAppBuyHardware.title',
    icon: 'svgs/icons/download-app'
  },
  [MilestoneTypes.ACTIVATE_PAYMENTS]: {
    title: 'setupGuide.milestones.activatePayments.title',
    icon: 'svgs/icons/bank'
  },
  [MilestoneTypes.SET_UP_ACCOUNT]: {
    title: 'setupGuide.milestones.setUpAccount.title',
    icon: 'svgs/icons/my-account'
  },
  [MilestoneTypes.SET_UP_RESTAURANT]: {
    title: 'setupGuide.milestones.setUpRestaurant.title',
    icon: 'svgs/icons/register'
  },
  [MilestoneTypes.SET_UP_KDS]: {
    title: 'setupGuide.milestones.setUpKDS.title',
    icon: 'svgs/icons/four-squares'
  },
  [MilestoneTypes.SET_UP_RETAIL]: {
    title: 'setupGuide.milestones.setUpRetail.title',
    icon: 'svgs/icons/shopping-bag'
  },
  [MilestoneTypes.SET_UP_ITEM_CATALOG]: {
    title: 'setupGuide.milestones.setUpItemCatalog.title.default',
    icon: 'svgs/icons/tag'
  },
  [MilestoneTypes.SET_UP_SPOS]: {
    title: 'setupGuide.milestones.setUpSPOS.title',
    icon: 'svgs/icons/register'
  },
  [MilestoneTypes.SET_UP_ONLINE_STORE]: {
    title: 'setupGuide.milestones.setUpOnlineStore.title',
    icon: 'svgs/icons/square-online'
  },
  [MilestoneTypes.SET_UP_INVOICES]: {
    title: 'setupGuide.milestones.setUpInvoices.title',
    icon: 'svgs/icons/invoice'
  },
  [MilestoneTypes.SET_UP_EMPLOYEES]: {
    title: 'setupGuide.milestones.setUpEmployees.title',
    icon: 'svgs/icons/employees'
  },
  [MilestoneTypes.SET_UP_ONLINE_CHECKOUT]: {
    title: 'setupGuide.milestones.setUpOnlineCheckout.title',
    icon: 'svgs/icons/online-checkout'
  },
  [MilestoneTypes.SET_UP_APPOINTMENTS]: {
    title: 'setupGuide.milestones.setUpAppointments.title',
    icon: 'svgs/icons/appointments'
  }
};

/**
 * This is an alternate config that simply changes the copy for the SET_UP_ACCOUNT Milestone.
 */
export const RstMilestonesConfig = {
  ...MilestonesConfig,
  [MilestoneTypes.SET_UP_ACCOUNT]: {
    title: 'setupGuide.milestones.configureDetails.title',
    icon: 'svgs/icons/my-account'
  }
};

/**
 * This array is used to sort milestones in setup guide. It currently includes all milestones
 * from the mixedUseMilestones and defaultMixedUseMilestones lists in Checklist's MilestoneLists.
 */
export const RstMilestoneOrdering = [MilestoneTypes.SET_UP_RESTAURANT, MilestoneTypes.ACTIVATE_PAYMENTS, MilestoneTypes.SET_UP_KDS, MilestoneTypes.SET_UP_RETAIL, MilestoneTypes.SET_UP_ITEM_CATALOG, MilestoneTypes.SET_UP_SPOS, MilestoneTypes.SET_UP_ONLINE_STORE, MilestoneTypes.SET_UP_INVOICES, MilestoneTypes.SET_UP_EMPLOYEES, MilestoneTypes.SET_UP_ONLINE_CHECKOUT, MilestoneTypes.SET_UP_ACCOUNT];